import { React, PT } from '@gasbuddy/react';
import { Grid } from 'semantic-ui-react';

export const PoiLocation = ({ poi }) => {
  if (!poi) {
    return null;
  }
  return (
    <Grid columns={1}>
      <Grid.Row>
        <Grid.Column textAlign="center">
          <div>{poi.name}</div>
          <div>{poi.alias}</div>
          <div>{poi.address.line_1}</div>
          <div>
            {poi.address.locality}
            {', '}
            {poi.address.region}
          </div>
          <div>{poi.address.postal_code}</div>
          <div>{poi.address.country}</div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};


PoiLocation.propTypes = {
  poi: PT.shape(
    {
      name: PT.string.isRequired,
      alias: PT.string,
      brand_id: PT.number,
      address: PT.shape({
        line_1: PT.string,
        line_2: PT.string,
        locality: PT.string,
        region: PT.string,
        country: PT.string,
        postal_code: PT.string,
      }).isRequired,
    },
  ).isRequired,
};
